import styled from 'styled-components'

export const PrecedentsListWrapper = styled.div`
  height: 100%;
`

export const Filename = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    transition: 0.3s;
  }
`

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacings[2]};

  span {
    font-size: ${({ theme }) => theme.fontSizes.sm};

    padding: ${({ theme }) => `${theme.spacings[1.5]} ${theme.spacings[4]}`};

    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 25px;
  }
`

type StatusProps = {
  approved?: boolean
}

export const Status = styled.div<StatusProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacings[2]};

  span {
    font-size: ${({ theme }) => theme.fontSizes.sm};

    padding: ${({ theme }) => `${theme.spacings[1.5]} ${theme.spacings[4]}`};

    color: ${({ theme, approved }) =>
      typeof approved === 'boolean'
        ? approved
          ? theme.colors.primary
          : theme.colors.danger
        : theme.colors.warning};
    background-color: ${({ theme, approved }) =>
      typeof approved === 'boolean'
        ? approved
          ? theme.colors.background
          : theme.colors.dangerLight
        : theme.colors.warningLight};
    border-radius: 1.25rem;
  }
`

export const DetailsLink = styled.button`
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.bloggerSans};
  font-size: 16px;
  margin: 5px 0;
  color: ${({ theme }) => theme.colors.secondary};

  &:hover {
    text-decoration: underline;
    transition: 0.3s;
  }
`

export const ButtonAddContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${({ theme }) => `${theme.spacings[6]} 0`};
`
